<template>
  <div
    v-if="showScrollToTop"
    class="scroll-to-top text-center"
    :class="{
      'scroll-to-top-higher': hasBeaconContainer,
      'scroll-to-top-higher-mobile': showHigher
    }"
    @click="scrollToTop"
  >
    Scroll to top
    <div class="icon-container mt-1 text-center">
      <font-awesome-icon icon="chevron-up" />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ScrollToTop',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      userHasScrolledDown: false,
      isMounted: false,
      hasBeaconContainer: false,
    };
  },
  computed: {
    showScrollToTop() {
      // jl: checks if any external components want to hide the 'scroll to top' button
      return this.userHasScrolledDown && !this.$store.state?.scrollToTop?.hideScrollToTop;
    },
    showHigher() {
      return this.$store.state.scrollToTop?.showHigher;
    },
  },
  mounted() {
    this.isMounted = true;
    window.addEventListener('scroll', this.windowScrollEvent);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScrollEvent);
    this.hasBeaconContainer = false;
  },
  methods: {
    scrollToTop() {
      if (this.isMounted) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    windowScrollEvent() {
      if (this.isMounted) {
        this.userHasScrolledDown = (window.scrollY >= window.screen.height);
        this.hasBeaconContainer = window && window.Beacon;
      }
    },
  },
};
</script>

<style scoped>
  .scroll-to-top {
    position: fixed;
    bottom: 75px;
    right: 15px;
    padding: 10px;
    background-color: #fafafa;
    color: #004446;
    font-size: 12px;
    border-radius: 5px;
    opacity: 0.5;
    z-index: 9999;
  }

  .scroll-to-top-higher,
  .scroll-to-top-higher-mobile {
    bottom: 105px;
  }

  .icon-container {
    height: 30px;
    width: 30px;
    margin: auto;
    border: 3px solid #004446;
    border-radius: 50%;
    color: #004446;
  }

  .scroll-to-top:hover,
  .scroll-to-top:active {
    opacity: 0.85;
    cursor: pointer;
  }

  /* Hide if disable body scrolling */
  /* stylelint-disable-next-line selector-no-qualifying-type */
  body.overflow-hidden .scroll-to-top {
    z-index: 0;
  }

  @media screen and (min-width: 992px) {
    .scroll-to-top,
    .scroll-to-top-higher-mobile {
      bottom: 15px;
    }

    .scroll-to-top-higher {
      bottom: 105px;
    }
  }
</style>
